export default function AttachRecommendationReportFolderDirective() {
  return {
    template: require('./attach-recommendation-report-folder.html'),
    scope: {
      recommendationId: '=',
      serviceId: '=',
      reportFolder: '=',
    },
    controller: 'AttachRecommendationReportFolderController',
    controllerAs: 'attachRecommendationReportFolderVM',
    bindToController: true,
    replace: true
  };
}
